import React, { useState, useEffect } from 'react';

export interface SubtitleWithTruncationProps {
  subtitle: string | null | undefined;
  isParentCollapsed?: boolean;
  className?: string;
}

const defaultSubtitleClassName = 'c-scm-syllabus-item__subtitle';
const subtitleIdPrefix = 'subtitle-content';
let subtitleIdCounter = 0;

const SubtitleWithTruncation = ({
  subtitle,
  isParentCollapsed = false,
  className = defaultSubtitleClassName
}: SubtitleWithTruncationProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [subtitleId] = useState(() => {
    subtitleIdCounter += 1;
    return `${subtitleIdPrefix}-${subtitleIdCounter}`;
  });
  const MAX_CHARS = 220;

  useEffect(() => {
    if (isParentCollapsed) {
      setIsExpanded(false);
    }
  }, [isParentCollapsed]);

  if (!subtitle) {
    return null;
  }

  if (subtitle.length <= MAX_CHARS) {
    return <div className={className}>{subtitle}</div>;
  }

  const truncatedText = subtitle.substring(0, MAX_CHARS);

  return (
    <div className={className} id={subtitleId}>
      {isExpanded ? subtitle : `${truncatedText}...`}
      {' '}
      <button
        type="button"
        className="u-els-debuttonize u-els-anchorize"
        onClick={() => setIsExpanded(prev => !prev)}
        aria-label={isExpanded ? 'Show less' : 'Show more'}
        aria-controls={subtitleId}
      >
        {isExpanded ? 'Show less' : 'Show more'}
      </button>
    </div>
  );
};

export default SubtitleWithTruncation;
